import { IconWrapper } from '../runtime';
export default IconWrapper('emoji', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M15 7.99976C15 11.8657 11.866 14.9998 8 14.9998C4.13401 14.9998 1 11.8657 1 7.99976C1 4.13376 4.13401 0.999756 8 0.999756C11.866 0.999756 15 4.13376 15 7.99976Z",
      "stroke": props.colors[0],
      "stroke-width": props.strokeWidth,
      "stroke-linejoin": props.strokeLinejoin,
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M11.027 8.88646C11.027 10.5583 9.3449 11.746 7.99987 11.746C6.65483 11.746 4.97266 10.5583 4.97266 8.88646C4.97266 7.91838 5.99617 8.7531 7.99987 8.75293C9.99422 8.75276 11.027 7.91837 11.027 8.88646Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M6.99512 5.74976C6.99512 6.30204 6.5474 6.74976 5.99512 6.74976C5.44283 6.74976 4.99512 6.30204 4.99512 5.74976C4.99512 5.19747 5.44283 4.74976 5.99512 4.74976C6.5474 4.74976 6.99512 5.19747 6.99512 5.74976Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  }), h("path", {
    "attrs": {
      "d": "M11 5.74976C11 6.30204 10.5523 6.74976 10 6.74976C9.44772 6.74976 9 6.30204 9 5.74976C9 5.19747 9.44772 4.74976 10 4.74976C10.5523 4.74976 11 5.19747 11 5.74976Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});